<template>
  <div class="login-box">
    <div class="header-logo">
      <img src="../../assets/imgs/image.png" />
    </div>
    <div class="frm-box">
      <div class="title">{{ $t("login.register") }}</div>
      <div>
        <van-form @submit="onSubmit">
          <van-field
            v-model="username"
            :placeholder="$t('login.teldesc')"
            class="frm-item"
            :rules="[{ required: true }]"
          />
          <van-field
            v-model="password"
            type="password"
            :placeholder="$t('login.pwddesc')"
            class="frm-item"
            :rules="[{ required: true }]"
          />
          <van-field
            v-model="code"
            :placeholder="$t('login.codedesc')"
            class="frm-item"
            :rules="[{ required: true }]"
          />
          <div style="margin: 16px">
            <van-button native-type="submit" class="frm-btn">{{
              $t("login.register")
            }}</van-button>
          </div>
        </van-form>
        <p>{{ $t("login.forget") }}</p>
        <p>{{ $t("login.noaccount") }}</p>
        <div style="margin: 16px">
          <van-button class="frm-btn" @click="toLogin">{{ $t("login.tologin") }}</van-button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
  
  <script>
import Footer from "@/components/footer/index.vue";
import { Toast } from 'vant';
export default {
  name: "RegisterView",
  components: { Footer },
  data() {
    return {
      username: null,
      lang: 'yn_yu',
      password: null,
      code: '',
    };
  },
  methods: {
    onSubmit() {
      this.$http({
        url: "member_register",
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang,
        },
      }).then((res) => {
        if (res.code == 200) {
          Toast.success(res.msg);
          localStorage.setItem("token", res.data);
          this.$router.push("/");
        } else {
          Toast(res.msg);
        }
      });
    },
    toLogin() {
        this.$router.push({ name: "login" });
    }
  }
};
</script>

<style>
</style>
